/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomContractVariableValueDto } from './CustomContractVariableValueDto';
import {
    CustomContractVariableValueDtoFromJSON,
    CustomContractVariableValueDtoFromJSONTyped,
    CustomContractVariableValueDtoToJSON,
    CustomContractVariableValueDtoToJSONTyped,
} from './CustomContractVariableValueDto';
import type { CustomContractFeesDto } from './CustomContractFeesDto';
import {
    CustomContractFeesDtoFromJSON,
    CustomContractFeesDtoFromJSONTyped,
    CustomContractFeesDtoToJSON,
    CustomContractFeesDtoToJSONTyped,
} from './CustomContractFeesDto';
import type { CustomContractGuaranteeDto } from './CustomContractGuaranteeDto';
import {
    CustomContractGuaranteeDtoFromJSON,
    CustomContractGuaranteeDtoFromJSONTyped,
    CustomContractGuaranteeDtoToJSON,
    CustomContractGuaranteeDtoToJSONTyped,
} from './CustomContractGuaranteeDto';

/**
 * 
 * @export
 * @interface CustomContractCommandDto
 */
export interface CustomContractCommandDto {
    /**
     * 
     * @type {string}
     * @memberof CustomContractCommandDto
     */
    riskId: string;
    /**
     * Unique identifier of the tunnel
     * @type {string}
     * @memberof CustomContractCommandDto
     */
    tunnelId: string;
    /**
     * Indicates if the contract is for an individual
     * @type {boolean}
     * @memberof CustomContractCommandDto
     */
    isIndividual?: boolean;
    /**
     * Identifier of the associated contract
     * @type {string}
     * @memberof CustomContractCommandDto
     */
    associatedContractId?: string | null;
    /**
     * List of custom tunnel fees
     * @type {Array<CustomContractFeesDto>}
     * @memberof CustomContractCommandDto
     */
    fees?: Array<CustomContractFeesDto>;
    /**
     * List of custom tunnel variables
     * @type {Array<CustomContractVariableValueDto>}
     * @memberof CustomContractCommandDto
     */
    variables?: Array<CustomContractVariableValueDto>;
    /**
     * List of selected guarantees for the tunnel
     * @type {Array<CustomContractGuaranteeDto>}
     * @memberof CustomContractCommandDto
     */
    guarantees?: Array<CustomContractGuaranteeDto>;
}

/**
 * Check if a given object implements the CustomContractCommandDto interface.
 */
export function instanceOfCustomContractCommandDto(value: object): value is CustomContractCommandDto {
    if (!('riskId' in value) || value['riskId'] === undefined) return false;
    if (!('tunnelId' in value) || value['tunnelId'] === undefined) return false;
    return true;
}

export function CustomContractCommandDtoFromJSON(json: any): CustomContractCommandDto {
    return CustomContractCommandDtoFromJSONTyped(json, false);
}

export function CustomContractCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomContractCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'riskId': json['riskId'],
        'tunnelId': json['tunnelId'],
        'isIndividual': json['isIndividual'] == null ? undefined : json['isIndividual'],
        'associatedContractId': json['associatedContractId'] == null ? undefined : json['associatedContractId'],
        'fees': json['fees'] == null ? undefined : ((json['fees'] as Array<any>).map(CustomContractFeesDtoFromJSON)),
        'variables': json['variables'] == null ? undefined : ((json['variables'] as Array<any>).map(CustomContractVariableValueDtoFromJSON)),
        'guarantees': json['guarantees'] == null ? undefined : ((json['guarantees'] as Array<any>).map(CustomContractGuaranteeDtoFromJSON)),
    };
}

export function CustomContractCommandDtoToJSON(json: any): CustomContractCommandDto {
    return CustomContractCommandDtoToJSONTyped(json, false);
}

export function CustomContractCommandDtoToJSONTyped(value?: CustomContractCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'riskId': value['riskId'],
        'tunnelId': value['tunnelId'],
        'isIndividual': value['isIndividual'],
        'associatedContractId': value['associatedContractId'],
        'fees': value['fees'] == null ? undefined : ((value['fees'] as Array<any>).map(CustomContractFeesDtoToJSON)),
        'variables': value['variables'] == null ? undefined : ((value['variables'] as Array<any>).map(CustomContractVariableValueDtoToJSON)),
        'guarantees': value['guarantees'] == null ? undefined : ((value['guarantees'] as Array<any>).map(CustomContractGuaranteeDtoToJSON)),
    };
}

